import React, { useState } from "react";
import "./UserLeftSidebar.css";
import profile from "../assets/images/profile.png";
import LogoutIcon from '@mui/icons-material/Logout';
import { NavLink } from "react-router-dom";//Navlink
 
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LocalOfferOutlinedIcon from '@mui/icons-material/LocalOfferOutlined';
import FavoriteBorderOutlinedIcon from '@mui/icons-material/FavoriteBorderOutlined';
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalMallOutlinedIcon from "@mui/icons-material/LocalMallOutlined"; 
 
 
export default function UserLeftSidebar() {
    const [openSidebar, setOpenSidebar] = useState(false);
  return (
   <div className='outerrrrr'>
     <div className="mobile-view-btn-text">
         <button className="menu-btn" onClick={() => setOpenSidebar(true)}>
            <MenuIcon/>
         </button>
         <div className='dashbord-header'>
            {/* <p className='title-dash'>Dashboard</p> */}
           <div className='dropdown-section d-flex align-items-center'>
            <div className="dropdown">
              <button className="btn dropdown-toggle d-flex align-items-center gap-3" type="button" data-bs-toggle="dropdown" aria-expanded="false" >
                <div className='profile-name-mobile'>
                  <img src={profile} alt="" />
                </div>
                <ExpandMoreIcon />
              </button>
 
              <ul className="dropdown-menu ">
                <li><a className="dropdown-item" href="#">Profile</a></li>
                <li><a className="dropdown-item" href="#">Support</a></li>
                <li><a className="dropdown-item" href="#">Logout</a></li>
              </ul>
            </div>
          </div>
         </div>
     </div>
 
    <div className={`iner-dashbord-left ${openSidebar ? "active" : ""}`}>
      <button className="close-btn" onClick={() => setOpenSidebar(false)}>
        <CloseIcon/>
      </button>
      <div className='profile-name'>
        <img src={profile} alt="" />
        <div className='name-mail'>
          <h4>DEEPAK SHARMA</h4>
          <p>Deepak@gmail.com</p>
        </div>
      </div>
 
      <div className='dashbord-list-section'>
        <ul>
            <li>
              <NavLink
                to="/dashboard"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <HomeOutlinedIcon /> Dashboard
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/purchasehistory"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <LocalOfferOutlinedIcon /> Purchase History
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/wishlist"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <FavoriteBorderOutlinedIcon />
                Wishlist
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/orderlist"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <LocalMallOutlinedIcon />
                Orders
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/profile"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <PersonOutlineOutlinedIcon /> Profile
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/support"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <HeadsetMicOutlinedIcon /> Support
              </NavLink>
            </li>

            <li>
              <NavLink
                to="/manageaddress"
                className={({ isActive }) => (isActive ? "active" : "")}
              >
                <LocationOnOutlinedIcon /> Manage Address
              </NavLink>
            </li>
          </ul>            
      </div>
 
      <div className='logout-btn'>
         <NavLink to="/">
            <LogoutIcon /> Logout
          </NavLink>
      </div>
 
    </div>
  </div>
  )
}
 